export default "__VITE_ASSET__BQ6pcEEt__"